import {inject, observer} from 'mobx-react';
import {rgba} from 'polished';
import * as React from 'react';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';
import {BaseButton} from '../../components/Button';
import Card, {CardBody, CardFooter, CardHeader} from '../../components/Card';
import Flex from '../../components/Flex';
import Icon from '../../components/Icon';
import Layout, {Main} from '../../components/Layout';
import Persona from '../../components/Persona';
import Text from '../../components/Text';
import {ListingProviderType} from '../../models/enums';
import {
  ListingModelType,
  ListingsListModelType
} from '../../models/ListingsListModel';
import {styled} from '../../utils';

interface WithInjectedProps {
  listingsList: ListingsListModelType;
}

const ListingsGrid = styled('div')({
  margin: -25
});

const ListingItem = styled(Flex)(({theme}) => ({
  boxSizing: 'border-box',
  padding: '20px 0px',
  borderLeft: `2px solid transparent`,
  borderBottom: '1px solid #F1F3F6',
  '&:nth-child(even)': {
    background: rgba('#F1F3F6', 0.3)
  },
  '&:hover': {
    background: rgba('#F1F3F6', 0.3),
    borderLeftColor: theme.color.secondary
  }
}));

const ListingInfo = styled(Flex)({
  boxSizing: 'border-box',
  borderRight: '1px solid #F1F3F6',
  padding: '0 20px',
  width: '50%'
});

const ListingImage = styled('img')({
  width: 87,
  borderRadius: 3
});

@inject('listingsList')
@observer
export default class Reservations extends React.Component<{}, {}> {
  public componentDidMount() {
    const params = {
      _limit: 10,
      _offset: 0,
      long_term: 'true'
    };
    this._withInjectedProps.listingsList.loadEntries(params);
  }

  public render() {
    const {
      pagedList,
      isLoaded,
      isLoading,
      totalCount,
      loadPreviousPage,
      loadNextPage,
      pagination: {hasNext, hasPrevious, hasCached}
    } = this._withInjectedProps.listingsList;

    return (
      <React.Fragment>
        <Helmet>
          <title>Listings</title>
        </Helmet>
        <Layout>
          <Main>
            {/* <Card>
              <CardBody>
                <Flex justify="flex-end" style={{marginBottom: 16}}>
                  <Input.Search
                    placeholder="Team ID"
                    onSearch={value => {
                      if (value) {
                        this._withInjectedProps.reservationsList.setFilterByTeamId(
                          parseInt(value, 10)
                        );
                      }
                    }}
                    allowClear={true}
                    type="number"
                    style={{width: 300}}
                  />
                  <Input.Search
                    placeholder="Search query"
                    onSearch={value => this._handleSearch(value)}
                    allowClear={true}
                    style={{width: 300}}
                  />
                </Flex>
              </CardBody>
            </Card> */}

            <Card>
              <CardHeader>
                <Flex justify="space-between">
                  <span>Listings {isLoaded ? `(${totalCount})` : null}</span>
                  <div>
                    {hasPrevious ? (
                      <BaseButton
                        disabled={isLoading}
                        onClick={loadPreviousPage}
                      >
                        <Icon name="left" />
                      </BaseButton>
                    ) : null}
                    {hasNext ? (
                      <BaseButton disabled={isLoading} onClick={loadNextPage}>
                        <Icon name="right" />
                      </BaseButton>
                    ) : null}
                  </div>
                </Flex>
              </CardHeader>

              <CardBody>
                <ListingsGrid>
                  {isLoading && !hasCached ? (
                    <Flex
                      center={true}
                      direction="column"
                      style={{height: 150}}
                    >
                      <Icon
                        spin={true}
                        name="loading"
                        size={24}
                        color="#7C4EF6"
                      />
                    </Flex>
                  ) : (
                    pagedList.map(
                      (listing: ListingModelType, index: number) => {
                        return (
                          <Link
                            key={index}
                            to={`/long-term-listings/${listing.id}`}
                            style={{color: 'inherit', textDecoration: 'none'}}
                          >
                            <ListingItem>
                              <ListingInfo>
                                <div style={{marginRight: 12}}>
                                  <ListingImage
                                    src={listing.previewImageUrl}
                                  />
                                </div>

                                <div>
                                  <Text
                                    withComponent="h5"
                                    fontSize={16}
                                    lineHeight="22px"
                                  >
                                    <Persona
                                      badge={
                                        listing.source as ListingProviderType
                                      }
                                    >
                                      {listing.name}
                                    </Persona>
                                  </Text>

                                  {listing.internalName ? (
                                    <Text
                                      color="secondary"
                                      fontSize={12}
                                      style={{marginTop: 8, marginBottom: 8}}
                                      withComponent="div"
                                    >
                                      {listing.internalName}
                                    </Text>
                                  ) : (
                                    ''
                                  )}

                                  {listing.address ? (
                                    <Text
                                      // color="secondary"
                                      fontSize={12}
                                      style={{marginTop: 8, marginBottom: 8}}
                                      withComponent="div"
                                    >
                                      {listing.address}
                                    </Text>
                                  ) : null}
                                </div>
                              </ListingInfo>

                              <ListingInfo>
                                <div style={{marginRight: 12}}>
                                  <Text fontSize={16}>
                                    {listing.team.name}
                                  </Text>
                                </div>
                              </ListingInfo>
                            </ListingItem>
                          </Link>
                        );
                      }
                    )
                  )}
                </ListingsGrid>
              </CardBody>

              {hasNext || hasPrevious ? (
                <CardFooter>
                  <Flex justify="flex-end">
                    {hasPrevious ? (
                      <BaseButton
                        disabled={isLoading}
                        onClick={loadPreviousPage}
                      >
                        <Icon name="left" />
                      </BaseButton>
                    ) : null}
                    {hasNext ? (
                      <BaseButton disabled={isLoading} onClick={loadNextPage}>
                        <Icon name="right" />
                      </BaseButton>
                    ) : null}
                  </Flex>
                </CardFooter>
              ) : null}
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Listings/Listings.tsx